/* eslint-env browser */

export default function defaultValue() {
  if (!document) {
    return {};
  }
  var _window = window,
    _window$location = _window.location,
    location = _window$location === void 0 ? {} : _window$location;
  return {
    name: document.title,
    url: location.href,
    id: location.href
  };
}